"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowDownward = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ArrowDownward = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M12.5 2a.5.5 0 01.5.5v16.17l4.44-4.45a.5.5 0 01.71 0l.7.71a.5.5 0 010 .71l-6.13 6.14a.75.75 0 01-.53.22h-.38a.77.77 0 01-.53-.22l-6.13-6.14a.5.5 0 010-.71l.71-.71a.49.49 0 01.7 0L11 18.67V2.5a.5.5 0 01.5-.5h1z" })); };
exports.ArrowDownward = ArrowDownward;
//# sourceMappingURL=arrow-downward.js.map